import axios from 'axios';

export const setCompleteProfile = async ({
  location,
  designation,
}) => {
  const path = `/api/admin/v1/user/completeUserDetails`;
  const userDetails = {
    location,
    designation,
  };
  const headers = {
    'Content-Type': 'application/json',
  };
  const { status, data } = await axios.post(path, userDetails, { headers });
  return { status, data };
};
